import {MenuItemModel} from '../views/models/menu-item.model';
import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {AppHotelService} from './app-hotel.service';
import {AppHotelModel} from '../views/models/app-hotel.model';
import {UserService} from './user.service';

export class PoisModel {
  header: string;
  title: string;
  items: MenuItemModel[];
  icon: string;

  constructor(header = '',
              title = '',
              items = [],
              icon = '') {
    this.header = header;
    this.title = title;
    this.items = items;
    this.icon = icon;
  }
}

@Injectable({providedIn: 'root'})
export class PoisService {
  lat = '';
  lng = '';
  pois = [];
  record_change$ = new BehaviorSubject<PoisModel[]>(this.pois);
  headers = ['atm,bank', 'bar', 'bus_station,subway_station', 'hospital,pharmacy', 'museum', 'park,zoo', 'car_rental,car_repair', 'shopping_mall', 'restaurant', 'cafe', 'spa',
    'church,mosque,synagogue'];
  title = ['Bank', 'Bar', 'Station', 'Health Care', 'Museum', 'Park', 'Car Rental', 'Shopping Mall', 'Restaurant', 'Cafe', 'SPA', 'Temple'];
  icons = ['atm.svg', 'cheers.svg', 'bus-stop.svg', 'first-aid-kit.svg', 'greek-temple.svg', 'park.svg', 'rent.svg', 'bags.svg', 'cutlery.svg', 'sign.svg', 'candles.svg', 'sagrada-familia.svg'];

  constructor(private hotelInfo: AppHotelService,
              private userService: UserService) {
  }

  googlePlaceApi(range: number) {
    this.hotelInfo.getHotelInfo(this.userService.record_change$.getValue().app_hotel_id).subscribe(
      (data: AppHotelModel) => {
        if (data == undefined || data.lat_lng == '') {
          return;
        }
        this.lat = data.lat_lng.split(',')[0];
        this.lng = data.lat_lng.split(',')[1];

        this.pois = [];
        this.record_change$.next(this.pois);
        this.pois = [];

        const latlang = new google.maps.LatLng(+this.lat, +this.lng);
        const service = new google.maps.places.PlacesService(document.createElement('div'));

        for (let i = 0; i < this.headers.length; i++) {
          setTimeout(() => {
            let item: MenuItemModel = new MenuItemModel();
            const types = this.headers[i].split(',');
            const y = new PoisModel();
            y.header = this.headers[i];
            y.title = this.title[i];
            y.icon = this.icons[i];
            for (let j = 0; j < types.length; j++) {
              const request = {
                location: latlang,
                radius: range.toString(),
                // keyword: [this.headers[i]],
                type: [types[j]]
              };
              // @ts-ignore
              service.nearbySearch(request, (results, status, next_page_token) => {
                if (results != null) {
                  if (results.length != 0) {
                    results.forEach(z => {
                      item = new MenuItemModel();
                      if (z.photos != undefined) {
                        item.image_url = z.photos[0].getUrl();
                      }
                      item.name = z.name;
                      item.activate_map_location = true;
                      item.map_location = z.geometry.location.lat() + ',' + z.geometry.location.lng();
                      y.items.push(item);
                    });
                    if (next_page_token.hasNextPage == true) {
                      // next_page_token.nextPage();
                    }
                  }
                }
              });
            }
            this.pois.push(y);
          }, i * 500);
        }

        setTimeout(() => {
          // console.log(this.pois);

          for (let i = this.pois.length - 1; i >= 0; i--) {
            if (this.pois[i].items.length == 0) {
              this.pois.splice(i, 1);
            }
          }

          this.record_change$.next(this.pois);
        }, 6000);
      },
      err => console.error(err)
    );
  }
}
